import React, { useState, useContext } from 'react';
import { Row, Col, message } from 'antd';
import ButtonDefault from '../../../../components/ButtonDefault/ButtonDefault';
import ButtonDefaultIcon from '../../../../components/ButtonDefaultIcon/ButtonDefaultIcon';
import FieldText from '../../../../components/FieldText/FieldText';
import PanelBase from '../../../../components/PanelBase/PanelBase';
import { UserContext } from '../../../../context/UserContext';
import { API } from '../../../../API/API';
import LoadSpin from '../../../../components/LoadSpin/LoadSpin';
import { MessageConst } from '../../../../const/MessageConst';
import { MessageBar, MessageBarType } from '@fluentui/react';
import { useNavigate } from 'react-router-dom';

const EmpNew = (props) => {

    const navigate = useNavigate();
    const { userInfo } = useContext(UserContext);

    const [initData, setInitData] = useState({ regno: null });
    const [data, setData] = useState({ ...initData });
    const [fieldmessage, setFieldMessage] = useState();
    const [warning, setWarning] = useState();
    const [loading, setLoading] = useState(false);
    const [linkname, setLinkName] = useState();

    const fieldOnChanged = async (key, text, field) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            setData(tData);
        }
    }

    const onSave = async () => {
        setWarning();
        setLinkName();
        if (data.empid) {

            if (data.status == "AC") {
                await API.post('/api/humanresource/employment/save_double_employment', [
                    {
                        "empid": data.empid,
                        "companyid": userInfo.companyid
                    }
                ]).then(response => {
                    if (response.status == 200 && response.data.rettype == 0) {
                        message.success(MessageConst.success);
                        onClear();
                        props.afterSave(data.empid);
                    }
                });
            } else {
                await API.post('/api/humanresource/employee/update_company_in_employee', [
                    {
                        "empid": data.empid,
                        "companyid": userInfo.companyid
                    }
                ]).then(response => {
                    if (response.status == 200 && response.data.rettype == 0) {
                        message.success(MessageConst.success);
                        onClear();
                        props.afterSave(data.empid);
                    }
                });
            }
        } else {
            setWarning("Мэдээлэл олдсонгүй.");
        }
    }

    const onPressSearch = async () => {
        setFieldMessage();
        setWarning();
        setLinkName();
        let tData = { ...initData };


        setLoading(true);
        await API.get('/api/humanresource/employee/get_not_local_employee_by_regno?companyid=' + userInfo.companyid + '&regno=' + (data.regno ? data.regno : ''), {
            ignoreRetType: true
        }).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {

                if (response.data.retdata?.length > 0) {
                    tData = response.data.retdata[0];
                }
            } else {
                setFieldMessage(response.data.retmsg ? response.data.retmsg : "Мэдээлэл олдсонгүй.");
                if (response.data.retdata?.length > 0) {
                    tData = response.data.retdata[0];
                    setLinkName(tData.regno);
                }
            }
        });

        setData(tData);
        setLoading(false);
    }

    const onPressEmp = () => {
        if (data.empid) {
            navigate('/hrsuite/employee/' + data.empid);
        }
    }

    const xypNotFound = (p_msg) => {
        message.warning(p_msg);
        setWarning(p_msg)
    }

    const onDismiss = () => {
        onClear();
        props.onDismiss();
    }

    const onClear = () => {
        setFieldMessage();
        setWarning();
        setLinkName();
        setData({ ...initData });
    }

    return (
        <PanelBase
            isOpen={props.isOpen}
            headerText={props.headerText}
            onDismiss={onDismiss}
            warning={warning}
            buttons={<div style={{ display: 'flex' }}>
                {data?.status ? (
                    <ButtonDefault text={data.status == "AC" ? "Давхар ажил эрхлэлт нэмэх" : "Хадгалах"} onClick={() => onSave()} />
                ) : (
                    null
                )}
            </div>}>
            <Row gutter={[16, 16]} style={{ marginTop: 25 }}>
                <Col span={19}>
                    <FieldText required onChanged={fieldOnChanged} title="Регистрийн дугаар" keyfield='regno' defaultValue={data.regno} message={fieldmessage} checkreq={fieldmessage ? true : false} onEnterClicked={onPressSearch} link={linkname} linkfunc={onPressEmp} />
                </Col>
                <Col span={5}>
                    <div style={{ marginRight: 16, width: '100%' }}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ fontSize: 14 }}>&nbsp;</div>
                        </div>
                        <div style={{ marginTop: 6 }}>
                            {loading ? (
                                <LoadSpin />
                            ) : (
                                <ButtonDefaultIcon full iconName="search" text="Шалгах" onClick={onPressSearch} />
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
            <div style={{ marginTop: 10 }}>
                {data.status == "AC" ? (<MessageBar messageBarType={MessageBarType.warning}>Энэ ажилтан өөр байгууллага дээр идэвхтэй ажил эрхэлж байна. Та давхар ажил эрхлэлтээр бүртгэх шаардлагатай бол нэмнэ үү!</MessageBar>) : null}
            </div>
            <div style={{ marginTop: 29, fontSize: 18 }}>
                Ажилтны мэдээлэл
            </div>
            {data.picturedata && (
                <div style={{ display: 'flex', alignItems: 'center', }}>
                    <div style={{ marginTop: 13, borderRadius: 28, overflow: 'hidden', border: 0 }}>
                        <img height={56} src={"data:image/png;base64, " + data.picturedata} />
                    </div>
                </div>
            )}
            <div style={{ marginTop: 13 }}>
                <FieldText disable={true} onChanged={fieldOnChanged} title="Нэр" keyfield='firstname' defaultValue={data.firstname} />
            </div>
            <div style={{ marginTop: 13 }}>
                <FieldText disable={true} onChanged={fieldOnChanged} title="Эцэг эхийн нэр" keyfield='lastname' defaultValue={data.lastname} />
            </div>
            <div>
                <div style={{ marginTop: 13 }}>
                    <FieldText disable={true} onChanged={fieldOnChanged} title="Код" keyfield='code' defaultValue={data.code} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldText disable={true} onChanged={fieldOnChanged} title="Байгууллага" keyfield='companyname' defaultValue={data.companyname} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldText disable={true} onChanged={fieldOnChanged} title="Дотоод нэгж" keyfield='departmentname' defaultValue={data.departmentname} />
                </div>
                <div style={{ marginTop: 13 }}>
                    <FieldText disable={true} onChanged={fieldOnChanged} title="Ажлын байр" keyfield='positionname' defaultValue={data.positionname} />
                </div>
            </div>
        </PanelBase>
    );
}

export default EmpNew;